
export default {
  name: 'YoutubeThumbnailDownloader',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Can YouTube thumbnail downloaders be free to use?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "A YouTube thumbnail downloader will be free to use. You can easily download any thumbnail with the help of a YouTube thumbnail downloader. There are websites available that offer free YouTube thumbnail downloading tools. All you need is to copy the video URL and paste it into the thumbnail downloader website; it will provide you with a thumbnail image of high quality."
          }
        },
        {
          "@type": "Question",
          "name": "How important are YouTube thumbnails?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "A YouTube thumbnail is essential for your video because it is the first thing your viewers see. A good thumbnail can attract more viewers and increase the chances of your video getting more views. It can also help your video stand out and make it more shareable on social media platforms. A well-designed thumbnail can also give your video a professional look and make it more appealing to viewers."
          }
        },
        {
          "@type": "Question",
          "name": "How often can I change YouTube thumbnails?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "YouTube allows creators to change their video thumbnails as often as they want. Yet, it is essential to remember that changing the thumbnail frequently can also negatively impact the video's performance."
          }
        },
        {
          "@type": "Question",
          "name": "What is the YouTube thumbnail size?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "In 2023, the thumbnail size will be 1280 x 720 pixels. Any version that drops below 640 pixels will cause you to experience image quality issues. Of course, the effectiveness of attracting viewers to your project is low."
          }
        },
        {
          "@type": "Question",
          "name": "Does changing the YouTube thumbnail affect views?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The answer is yes! Changing the thumbnail can affect the views your video receives. However, the extent to which it affects views depends on various factors, such as the number of subscribers you have, the engagement rate of your audience, and the quality of your new thumbnail. If you have a small subscriber base, changing the thumbnail may significantly impact views more than having a large following."
          }
        }
      ]
    };
  },
  data () {
    return {
      data: '',
      form: this.$vform({
        url: null
      })
    }
  },
  methods: {
    YoutubeThumbnailDownloader() {
        this.form.post(`/tool/youtube-thumbnail-downloader`, { progress: false }).then(res => {
          this.data = Object.values(res.data);
        }).catch(e => {
          console.log(e);
        });
    },
    onSample(){
        this.form.url = 'https://youtu.be/xN1WOlptE58';
    },
    onReset(){
        this.form.reset();
        this.data = '';
    }
  }
}
